export const supportQueryKeys = {
  all: ['support'] as const,
  list: () => [...supportQueryKeys.all, 'list'] as const,
  detail: (id: string) => [...supportQueryKeys.all, 'detail', id] as const,
  // Mutation key for an in-flight reply; the detail poll pauses while it runs so
  // a refetch can't drop the optimistic bubble mid-send (see useSupportRequest).
  replyMutation: (id: string) =>
    [...supportQueryKeys.all, 'reply', id] as const,
};
